module.exports = __webpack_public_path__ + "static/img/znbx_pic2.2.7376c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/advantage/znbx_pic2.2.png
// module id = n8nL
// module chunks = 0